<template>
    <div class="modal"  @click.self="closePopup">
      <div class="modal-content">
        <div class="tree">
        <!-- XML Tree Wrapper mit Tree und Initialisierungsfunktion -->
        <xmlTreeWrapper @shareNodeModal="setPath" />
        </div>
        <!-- XPath und Placeholder Eingabefelder -->
        <div class="form-group">
          <label for="xpath">XPath</label>
          <input type="text" id="xpath" v-model="selectedXPath" readonly />
        </div>
        <div class="form-group">
          <label for="placeholder">{{ $t('XmlModal.PlaceholderName') }}</label>
          <div class="placeholdersEnabled"> {{ $t('XmlModal.XPathPlaceholder') }}
            <input type="checkbox" id="usePlaceholder" v-model="usePlaceholder" />
          </div>
          <input type="text" id="placeholder" v-model="placeholder" placeholder="Enter Placeholder Name" />
        </div>
        <!-- Save Button -->
        <button @click.prevent="saveMapping">{{ $t('XmlModal.Save') }}</button>
      </div>
    </div>
  </template>
  
  <script>
import xmlTreeWrapper from './XTree/xmlTreeWrapper.vue'; // Importiere die XML Tree Komponente
import { mapActions, mapState } from 'vuex'; // Importiere mapActions von Vuex
  
  export default {
    name: 'xmlModal',
    components: {
      xmlTreeWrapper,
    },
    props:{
      text: String
    },
    data() {
      return {
        selectedXPath: '', // Speichert den ausgewählten XPath
        placeholderName: '', // Placeholder Name vom Nutzer
        usePlaceholder: false // Checkbox für die Verwendung des XPath als Placeholder
      };
    },
    computed:{
      ...mapState(['xPathPlaceholders']),
      placeholder: {
        get() {
          return this.placeholderName;
        },
        set(value) {
          if(this.usePlaceholder) {
            newPlaceholder = `@${this.selectedXPath.substring(this.selectedXPath.lastIndexOf('/') + 1)}`; // Erstellt den Placeholder aus dem letzten Teil des XPaths
            this.placeholderName = newPlaceholder;
          } else {
            this.placeholderName = value;
        }
      }
    }},
    methods: {
      ...mapActions(['updateXPathPlaceholders']),
      // Wird ausgeführt, wenn setPath von xmlTreeWrapper emitted wird
      setPath(node) {
        console.log(node.xpath)
        this.selectedXPath = node.xpath; // Aktualisiert den XPath im Inputfeld
      },
      saveMapping() {
        if (!this.selectedXPath || !this.placeholderName) {
          alert('Bitte sowohl den XPath als auch den Placeholder Namen ausfüllen.');
          return;
        }
  
        // Hier kannst du das Mapping speichern, z.B. im Vuex-Store oder an eine API senden
        const newMapping = {
          placeholder: this.placeholderName,
          xpath: this.selectedXPath,
        };
        console.log('Mapping gespeichert:', newMapping);
        const currentMapping = this.xPathPlaceholders;
        if(currentMapping[0].xpath !== "") {
          currentMapping.push(newMapping);
        } else {
          currentMapping.splice(0, 1, newMapping);
        }
        console.log(currentMapping);
        this.updateXPathPlaceholders(currentMapping); // Speichert das Mapping im Vuex-Store
        this.$emit('markPlaceholder', newMapping.placeholder); // Emitte ein Event, um das Mapping im Editor zu markieren,
        this.$emit('close', newMapping.placeholder)
      },
      closePopup() {
      this.$emit('close');
    },
  },
    watch: {
      selectedXPath(value) {
        if(this.usePlaceholder == true) {
          this.placeholderName = `@${value.substring(value.lastIndexOf('/') + 1)}`;
        }
      },
      usePlaceholder(value) {
        if(value === true) {
          this.placeholderName = `@${this.selectedXPath.substring(this.selectedXPath.lastIndexOf('/') + 1)}`;
        }
      }
    },
    mounted() {
      this.placeholderName = this.text;
    }
  };
  </script>
  
  <style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
  }
  
  .tree {
    margin-bottom: 15px;
    width:100%;
    height: 300px;
    overflow: scroll;
    border: 1px solid #ccc;
  }
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    text-align: left;
    margin-bottom: 5px;
  }
  
  input {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }
  
  button {
    padding: 10px 15px;
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    cursor:pointer;
  }

  .placeholdersEnabled {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 14px;
    font-style: italic;
  }
  </style>
  